function parseNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function formatPrice(value, currency) {
  const n = parseNumber(value);
  if (n === null) return "";
  return `${n} ${currency}`;
}

export class ProductVariantController {
  constructor() {
    this.variantItems = Array.from(document.querySelectorAll(".js-product-variant"));
    this.selectedVariantInput = document.querySelector(".js-selected-variant-id");
    this.priceWrap = document.querySelector(".js-product-price");
    this.priceOld = document.querySelector(".js-product-price-old");
    this.priceNew = document.querySelector(".js-product-price-new");

    this.bind();
  }

  bind() {
    if (!this.variantItems.length || !this.priceWrap || !this.priceNew) return;

    this.variantItems.forEach((item) => {
      item.addEventListener("click", () => {
        this.variantItems.forEach((it) => it.classList.remove("is-default"));
        item.classList.add("is-default");

        const variantId = item.dataset.variantId || "";
        if (this.selectedVariantInput) {
          this.selectedVariantInput.value = variantId;
        }

        const currency = this.priceWrap.dataset.currency || "TRY";
        const price = item.dataset.variantPrice || "";
        const discount = item.dataset.variantDiscount || "";

        if (discount) {
          if (this.priceOld) {
            this.priceOld.hidden = false;
            this.priceOld.textContent = formatPrice(price, currency);
          }
          this.priceNew.textContent = formatPrice(discount, currency);
        } else {
          if (this.priceOld) {
            this.priceOld.hidden = true;
            this.priceOld.textContent = "";
          }
          this.priceNew.textContent = formatPrice(price, currency);
        }
      });
    });
  }
}
